import React from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
  return (
    <div className="max-w-[680px] mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold text-sage mb-6">Kontakt oss</h1>

      <p className="text-text-primary leading-relaxed mb-8">
        Har du spørsmål, tilbakemeldinger eller trenger hjelp? Vi hører gjerne fra deg.
        Send oss en e-post, så tar vi kontakt så snart vi kan.
      </p>

      {/* Email contact */}
      <div className="bg-white rounded-xl border border-border-light p-6 mb-10">
        <p className="text-sm text-text-muted mb-1">E-post</p>
        <a
          href="mailto:post@coord.no"
          className="text-primary font-medium text-lg hover:underline break-all"
        >
          post@coord.no
        </a>
      </div>

      {/* Personvernforespørsler */}
      <section className="mb-10">
        <h2 className="text-xl font-semibold text-sage mb-3">For personvernforespørsler</h2>
        <p className="text-text-primary leading-relaxed">
          For spørsmål om personvern og dine rettigheter, se vår{' '}
          <Link to="/privacy" className="text-primary hover:underline">personvernerklæring</Link>{' '}
          eller kontakt oss på{' '}
          <a href="mailto:post@coord.no" className="text-primary hover:underline">post@coord.no</a>.
        </p>
      </section>

      {/* Footer info */}
      <footer className="border-t border-border-light pt-6 text-sm text-text-muted">
        <p>Coord AS</p>
        <p>Org.nr: 933 971 376</p>
        <p>Askim, Norge</p>
      </footer>
    </div>
  );
};

export default Contact;
